import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Logo from "./../../img/UCSB-Registrar.svg";

import "./UcsbHeader.scss";

export const UcsbHeader = () => {
	const [isExpandedQuickLinks, setExpandedQuickLinks] = useState<boolean>(false);

	const navBarStyle= {
		paddingLeft: '16px',
		paddingRight: '16px'
	}

	const regionNavigation = {
		    borderBottom: '1px solid #eef0f2',
    		padding: '40px 0 16px 0'
	}

	return (
		<header>
			<div id="eyebrow">
				<div className="inner" style={{fontSize:'14px'}}>
					<div className="items">
						<div className="item">
							<a href="https://ucsb.edu" className="edu-link">
								University of California, Santa Barbara
							</a>
						</div>
						<div className="item d-none d-sm-block">
							<div className="inner">
								<div className="gold" style = {{backgroundColor: '#FEBC11'}}>
                            		<a className="gold" href="https://my.sa.ucsb.edu/gold/login.aspx">GOLD</a>
                          		</div>
								<div className="give">
									<a href="https://giving.ucsb.edu/?utm_source=ucsb-homepage&amp;utm_medium=give-button&amp;utm_campaign=giving-site">Give</a>
								</div>

								<div className={isExpandedQuickLinks ? "quick-links expanded" : "quick-links"}>
									<a
										href="#"
										onClick={() => {
											setExpandedQuickLinks(!isExpandedQuickLinks);
										}}
									>
										Quick Links <FontAwesomeIcon icon={isExpandedQuickLinks ? faCaretUp : faCaretDown} />
									</a>
									{isExpandedQuickLinks && (
										<ul className="menu nav">
											<li>
												<a href="https://registrar.sa.ucsb.edu/helpful-resources/faculty-staff">Office of the Registrar</a>
											</li>
											<li>
												<a href="https://www.policy.ucsb.edu/policies/privacy-notification-statement-uc-santa-barbara-web-sites">Privacy</a>
											</li>
											<li>
												<a href="https://www.ucsb.edu/terms-of-use">Terms of Use</a>
											</li>
											<li>
												<a href="https://registrar.sa.ucsb.edu/accessibility">Web Accessibility</a>
											</li>
										</ul>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="container-fluid">
				<div className="navbar-header" style={navBarStyle}>
					<div className="region region-navigation" style={regionNavigation}>
						<a className="logo navbar-btn pull-left logo-size-1" href="https://registrar.sa.ucsb.edu" title="Home" rel="home">
							<img src={Logo} alt="University of California Santa Barbara Registrar Logo" />
						</a>
					</div>
				</div>
				
			</div>
		</header>
	);
};
